(function() { module.exports = window["VueCompositionAPI"]; }());